import { render } from "./ModulTypeAttributeDetailVx.vue?vue&type=template&id=37ff1fd0"
import script from "./ModulTypeAttributeDetailVx.vue?vue&type=script&lang=js"
export * from "./ModulTypeAttributeDetailVx.vue?vue&type=script&lang=js"

import "./ModulTypeAttributeDetailVx.vue?vue&type=style&index=0&id=37ff1fd0&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__